export default "__VITE_ASSET__30b141aa__"